import { render, staticRenderFns } from "./ServicePeopleAdd.vue?vue&type=template&id=0055d685"
import script from "./ServicePeopleAdd.vue?vue&type=script&lang=js"
export * from "./ServicePeopleAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports